import React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'components/layout';
import { Text } from 'components/Text';

const ScheduleSection = ({ title, children, contentWrapperProps, ...rest }) => (
  <Row {...rest}>
    <Col span={24}>
      <ScheduleSectionTitle>{title}</ScheduleSectionTitle>
    </Col>
    <Col span={24} {...contentWrapperProps}>
      {children}
    </Col>
  </Row>
);

const ScheduleSectionTitle = styled(Text)`
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  /* Grey / grey-9 */
  color: #45494D;
  margin: 16px 0px;
  text-transform: uppercase;
`;

export default ScheduleSection;
